import { get, isNumber } from 'lodash';

const calculateVolumeDiscount = ({ amount, percentOff }) => {
  if (!amount || !percentOff) return null;

  const discount = amount * (percentOff / 100);
  return amount - discount;
};

const calculateBestVolumeDiscount = ({ thresholds, amount, currency }) => {
  if (
    !amount ||
    !currency ||
    !Array.isArray(thresholds) ||
    thresholds.length === 0
  ) {
    return null;
  }

  const bestPercentOff = Math.max(
    ...thresholds.map(({ percentOff }) => percentOff)
  );
  const highestQuantity = Math.max(
    ...thresholds.map(({ quantity }) => quantity)
  );
  const bestAmount = calculateVolumeDiscount({
    amount,
    percentOff: bestPercentOff
  });
  return {
    price: {
      currency,
      amount: bestAmount
    },
    quantity: highestQuantity
  };
};

const getInventoryItemBestVolumeDiscount = inventoryItem => {
  return calculateBestVolumeDiscount({
    thresholds: get(inventoryItem, 'volumeDiscount.thresholds'),
    amount: get(inventoryItem, 'price.amount'),
    currency: get(inventoryItem, 'price.currency')
  });
};

function getVolumeDiscountsAboveThreshold(volumeDiscounts, threshold) {
  return volumeDiscounts.filter(discount => discount.percentOff > threshold);
}

/**
 * For a given input volume discount object,
 * we remove any volume discount items with discount percentages
 * lower or equal to the threshold.
 *
 * Returns a volume discount object with discounts greater than the threshold.
 * @param {{thresholds:{percentOff:number, quantity:number}[]}} volumeDiscount
 * @param {number} threshold threshold to filter volume discount items
 * @returns {{thresholds:{percentOff:number, quantity:number}[]}} filtered volume discounts
 */
const getVolumeDiscountsGreaterThanThreshold = (volumeDiscounts, threshold) => {
  return isNumber(threshold) && volumeDiscounts
    ? {
        thresholds: getVolumeDiscountsAboveThreshold(
          volumeDiscounts.thresholds,
          threshold
        )
      }
    : volumeDiscounts;
};

/**
 *
 * @param {* | null} bestVolumeDiscount bestDiscountObject
 * @param {* | null} discount discount pobject
 * @param {number} bestVolumeDiscount.price.amount volume Discount Price
 * @param {number} discount.discountedPrice discounted price amount
 * @returns {boolean} true if the discount is a lower price than the volume discount
 */
const isDiscountCheaperThanOrEqualToVolumeDiscount = (
  bestVolumeDiscount,
  discount
) => {
  const volumeDiscountPrice = get(
    bestVolumeDiscount,
    ['price', 'amount'],
    Number.POSITIVE_INFINITY
  );

  const discountPrice = get(
    discount,
    'discountedPrice',
    Number.POSITIVE_INFINITY
  );

  return discountPrice <= volumeDiscountPrice;
};

export {
  calculateVolumeDiscount,
  calculateBestVolumeDiscount,
  getInventoryItemBestVolumeDiscount,
  getVolumeDiscountsGreaterThanThreshold,
  isDiscountCheaperThanOrEqualToVolumeDiscount
};
